import { render, staticRenderFns } from "./PdpAddToCart.vue?vue&type=template&id=710dc5cc&"
import script from "./PdpAddToCart.vue?vue&type=script&lang=js&"
export * from "./PdpAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports